import type { GraphEntityType } from "@salesko/contracts";
import {
  Building2,
  CalendarDays,
  CircleDollarSign,
  StickyNote,
  UserRound,
  type LucideIcon
} from "lucide-react";
import type { DetailTab } from "./types";

export const entityMeta = {
  person: {
    color: "#4a8cb0",
    icon: UserRound,
    tab: "people",
    tone: "person"
  },
  organisation: {
    color: "#6ba872",
    icon: Building2,
    tab: "companies",
    tone: "company"
  },
  event: {
    color: "#d9974f",
    icon: CalendarDays,
    tab: "events",
    tone: "event"
  },
  opportunity: {
    color: "#cba94f",
    icon: CircleDollarSign,
    tab: "opportunities",
    tone: "opportunity"
  },
  note: {
    color: "#837a6a",
    icon: StickyNote,
    tab: "notes",
    tone: "note"
  }
} satisfies Record<
  GraphEntityType,
  {
    color: string;
    icon: LucideIcon;
    tab: DetailTab;
    tone: string;
  }
>;

// Ego-center accent for the "you" node. Deliberately outside the 5 entity colors:
// on the self node, color encodes identity, not category. Warm ivory reads as a
// home-base beacon against the muted, earthy entity palette.
export const SELF_NODE_COLOR = "#f0e6cc";
